/**
 * Set during {@link setupOidcDiscovery} so the login screen can explain why
 * “Continue in browser” does nothing when discovery failed (e.g. API 502).
 */
export const oidcDiscoveryState = {
  loaded: false,
  errorMessage: null as string | null,
};
